import {mutations} from "./mutations";
import {actions} from "./actions";
import {getters} from "./getters";

const state = {
    branchen: [],
    errorBranchen: false,
    loadingBranchen: false
}

const branchenModule = {
    state,
    mutations,
    actions,
    getters
}

export default branchenModule;